<template>
  <section :class="$style.card">
    <header :class="$style.header">
      <div :class="$style.titleWrapper">
        <div :class="$style.darts">
          <ui-icon name="darts" :class="$style.dartsIcon" />
        </div>
        <h2 :class="$style.title">Pick’em</h2>
        <button type="button" :class="$style.guide" @click="emit('open-guide')">
          <ui-icon name="info-outline" :class="$style.guideIcon" />
          <span :class="$style.guideText">Правила</span>
        </button>
      </div>
      <p :class="$style.subtitle">
        Расставляй команды по местам в турнире — чем точнее прогноз, тем больше
        призов ты получишь!
      </p>
    </header>
    <div>
      <div :class="$style.tournamentInfo" v-if="tournament">
        <h2 :class="$style.tournamentInfoTitle">{{ tournament.name }}</h2>
        <p :class="$style.tournamentInfoDates">{{ dateRangeText }}</p>
      </div>

      <stages-sidebar-list
        v-if="stages.length"
        :stages="stages"
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event)"
      />
    </div>

    <all-tournaments-link />
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type {
  StageSummary,
  Tournament
} from '~/api/modules/starters/pickem/types'
import UiIcon from '~/ui-core/components/icon/index.vue'
import { getDateRangeText } from '~/utils/get-date-range-text'
import AllTournamentsLink from './AllTournamentsLink.vue'
import StagesSidebarList from './StagesSidebarList.vue'

defineOptions({ name: 'PickemIntroCard' })

const props = defineProps<{
  stages: StageSummary[]
  modelValue: number | null
  tournament: Tournament
}>()

const emit = defineEmits<{
  'update:modelValue': [value: number]
  'open-guide': []
}>()

const dateRangeText = computed(() =>
  getDateRangeText(props.tournament.start_at, props.tournament.end_at)
)
</script>

<style lang="scss" module>
.card {
  display: flex;
  flex-direction: column;
  gap: 1.6em;

  padding: 2.4em;
  border-radius: 2em;
  background-color: color-get(--root-rgb-bg-card);
}

.header {
  padding-bottom: 1.2em;
  border-bottom: 1px solid color-get(--root-rgb-bg-border);
}

.darts {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4em;
  height: 2.4em;
  background: var(--root-gradient-bg-2);
  border-radius: 0.8em;
}

.dartsIcon {
  width: 1.6em;
  height: 1.6em;
  color: color-get(--root-rgb-text-inverse);
}

.titleWrapper {
  display: flex;
  align-items: center;
  gap: 0.8em;
  margin-bottom: 1.2em;
}

.guide {
  display: flex;
  align-items: center;
  gap: 0.4em;

  margin-left: auto;

  color: color-get(--root-rgb-accent-2);
}

.guideIcon {
  width: 1.6em;
  height: 1.6em;
}

.guideText {
  @include typo-get(label-m);
}

.title {
  @include typo-get(headline-s);
  color: color-get(--root-rgb-text-1);
}

.subtitle {
  @include typo-get(body-s);
  line-height: normal;
  color: color-get(--root-rgb-text-2);
}

.tournamentInfo {
  display: flex;
  flex-direction: column;
  gap: 0.4em;
  margin-bottom: 0.8em;
}

.tournamentInfoTitle {
  @include typo-get(subhead-s);
  color: color-get(--root-rgb-text-1);
}

.tournamentInfoDates {
  @include typo-get(body-xs);
  color: color-get(--root-rgb-text-2);
}
</style>
